export const PCI_TRACKING_NAME = 'pci-queue'
